export default __webpack_public_path__ + "static/media/random-icon.d12745f3.svg";